var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "nb-global-preloader" } }, [
    _c(
      "div",
      { staticClass: "ctn-preloader", attrs: { id: "ctn-preloader" } },
      [
        _c("div", { staticClass: "round_spinner" }, [
          _c("div", { staticClass: "spinner" }),
          _c(
            "div",
            { staticClass: "text" },
            [
              _c("svg-icon", {
                staticClass: "sing-up-input-icon",
                staticStyle: { width: "130px" },
                attrs: { "icon-class": "logo-sp365-dark", width: "130" }
              })
            ],
            1
          )
        ]),
        _vm._m(0)
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "txt-loading" }, [
      _c(
        "span",
        {
          staticClass: "letters-loading",
          attrs: { "data-text-preloader": "C" }
        },
        [_vm._v("C")]
      ),
      _c(
        "span",
        {
          staticClass: "letters-loading",
          attrs: { "data-text-preloader": "A" }
        },
        [_vm._v("A")]
      ),
      _c(
        "span",
        {
          staticClass: "letters-loading",
          attrs: { "data-text-preloader": "S" }
        },
        [_vm._v("S")]
      ),
      _c(
        "span",
        {
          staticClass: "letters-loading",
          attrs: { "data-text-preloader": "P" }
        },
        [_vm._v("P")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }